import Notify from './notifyActions'
export const SET_PROFILE = 'SET_PROFILE'

export const setProfile = (profile) => {
  return {
    type: SET_PROFILE,
    profile: profile
  }
}

export const GET_PROFILE = 'GET_PROFILE';
export const getProfile = () => {
  return {
    type: GET_PROFILE
    // profile: {
    //   access_token: sessionStorage.getItem('access_token'),
    //   id_token: sessionStorage.getItem('id_token'),
    //   expires_at: sessionStorage.getItem('expiresAt'),
    //   profile: JSON.parse(sessionStorage.getItem('profile'))
    // }
  }
}

export const PASSWORD_CHANGE = 'PASSWORD_CHANGE'
export const PASSWORD_CHANGE_SUCCESSFULL_TOAST = 'password_change_successfull_toast'
export const passwordChange = (data) => {
  return (dispatch,getState) => {
    return new Promise((resolve,reject) => {
      dispatch({
        type: PASSWORD_CHANGE,
        payload: {
          request: {
            mode: 'no-cors',
            url: 'changepassword',
            method: 'Post',
            data: { request: data }
          }
        }
      }).then(response => {
        if (response.payload.data.success) {
          dispatch(Notify.success(PASSWORD_CHANGE_SUCCESSFULL_TOAST))
          resolve();
        }else{
          reject(response.payload.data)
        }
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/profileActions.js